function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41 8.44v26.563c0 .503-.386.932-.883.99L40 36H1.367c-.708 0-1.29-.495-1.36-1.125L0 34.747V8.44h41zm-19.084 3.467L13.03 23.31a.378.378 0 00-.033.422.451.451 0 00.395.222h6.554l-1.656 6.834c-.046.19.06.381.252.46.192.08.42.022.542-.135L27.97 19.71a.379.379 0 00.033-.423.452.452 0 00-.394-.22h-6.555l1.657-6.835a.4.4 0 00-.253-.46.469.469 0 00-.542.135zM19.133 0v5.934H.801L11.332.217c.215-.115.491-.19.788-.21L12.3 0h6.833zm2.732 0H28.7c.303 0 .594.055.832.153l.135.064 10.532 5.717H21.865V0H28.7z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgDeliveryExpress = function SvgDeliveryExpress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliveryExpress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivery-express.ddd616ee.svg";
export { ForwardRef as ReactComponent };